import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ReportComponent } from "./components/report/report.component";

const reportRoutes: Routes = [
  {
    path: "",
    component: ReportComponent,
    data: {
      title: "InitialClaimReport",
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(reportRoutes)],
  exports: [RouterModule],
})
export class ReportRoutingModule {}
